const BOT_NAMES = {
  gptbot: "GPTBot", claudebot: "ClaudeBot", perplexitybot: "PerplexityBot",
  "google-extended": "Google-Extended", "oai-searchbot": "OAI-SearchBot",
};
export const prettyBot = (b) => BOT_NAMES[String(b).toLowerCase()] || b;
